import React from "react";
import { Collapse, Switch } from "antd";
import {
    FilterValueSelector,
    FilterNameSelector,
    ConceptsSelector,
    MatchTypeSelector,
    PageSizeSelector,
    FilterDriverFieldSelector,
    FilterOverTimeSelector,
    CombinedConceptSelector,
    IncludeExamples,
    VisualizeSelector,
} from "./shared";
import { WidgetNames } from "../../../constants/WidgetNames";
import { ScoreFilterWithInterval } from "./shared/ScoreFilterWithInterval";
import { NPSOverTimeFilter } from "./shared/NPSOverTimeFilter";

export const DashboardFilters = ({ props, additionalFilters }) => {
    const {
        metaDataQu,
        dataList,
        sentimentDisabled,
        conceptTypeDay,
        conceptList,
        setConceptList,
        setSelectedLocalConcepts,
        selectedLocalConcepts,
        localConceptOptions,
        selectedFieldName,
        setSelectedFieldName,
        selectedFieldValue,
        setSelectedFieldValue,
        fieldValues,
        filters,
        setFilters,
        selectedDateField,
        selectedPageSize,
        setItemsPerPage,
        selectedFieldDriverName,
        setSelectedFieldDriverName,
        interval,
        setIntervalDate,
        selectedDateName,
        setSelectedDateName,
        includeExamples,
        setIncludeExamples,
        visualizeType,
        setVisualizeType,
        driverInterval,
        setDriverInterval,
        widget,
        smoothLine,
        setSmoothLine,
        setDisplayName
    } = props;

    const handleChangeType = (type) => {
        props.setConceptTypeDay(type);
        setConceptList("");
    };

    const filterItems = {
        conceptLists: {
            key: "conceptLists",
            label: "Concept Lists:",
            children: (
                <CombinedConceptSelector
                    sentimentDisabled={sentimentDisabled}
                    handleChangeType={handleChangeType}
                    conceptTypeDay={conceptTypeDay}
                    conceptList={conceptList}
                    setConceptList={setConceptList}
                    setSelectedLocalConcepts={setSelectedLocalConcepts}
                    conceptLists={dataList}
                />
            ),
            showArrow: false,
        },
        concepts: {
            key: "concepts",
            label: "Concepts:",
            children: (
                <ConceptsSelector
                    selectedLocalConcepts={selectedLocalConcepts}
                    setSelectedLocalConcepts={setSelectedLocalConcepts}
                    localConceptOptions={localConceptOptions}
                    setConceptList={setConceptList}
                />
            ),
            showArrow: false,
        },
        matchType: {
            key: "matchType",
            label: "Match Type:",
            children: (
                <MatchTypeSelector
                    selectedType={props.seletctedType}
                    setSelectedType={props.setSeletctedType}
                />
            ),
            showArrow: false,
        },
        filterName: {
            key: "filterName",
            label: "Filter Name:",
            children: (
                <FilterNameSelector
                    mode={"multiple"}
                    selectedFieldName={selectedFieldName}
                    setSelectedFieldName={setSelectedFieldName}
                    metaData={metaDataQu?.metaData}
                />
            ),
            showArrow: false,
        },
        filterValue: {
            key: "filterValue",
            label: "Filter Value:",
            children: (
                <FilterValueSelector
                    dateTypeMetadata={props.dateTypeMetadata}
                    selectedFieldName={selectedFieldName}
                    selectedFieldValue={selectedFieldValue}
                    setSelectedFieldValue={setSelectedFieldValue}
                    fieldValues={fieldValues}
                    setFilters={setFilters}
                    filters={filters}
                    selectedDateField={selectedDateField}
                    metaDataDate={metaDataQu?.metaDataDate}
                />
            ),
            showArrow: false,
        },
        pageSize: {
            key: "pageSize",
            label: "Page Size:",
            children: (
                <PageSizeSelector
                    selectedPageSize={selectedPageSize}
                    setSelectedPageSize={setItemsPerPage}
                />
            ),
            showArrow: false,
        },

        filterDriver: {
            key: "filterDriver",
            label: "Filter Driver Field:",
            children: (
                <FilterDriverFieldSelector
                    selectedFieldDriverName={selectedFieldDriverName}
                    setSelectedFieldDriverName={setSelectedFieldDriverName}
                    metaDataDrivers={metaDataQu?.metaDataDrivers}
                />
            ),
            showArrow: false,
        },
        filterScore: {
            key: "filterScore",
            label: "Filter Score:",
            children: (
                <FilterDriverFieldSelector
                    widget={widget}
                    setDisplayName={setDisplayName}
                    selectedFieldDriverName={selectedFieldDriverName}
                    setSelectedFieldDriverName={setSelectedFieldDriverName}
                    metaDataDrivers={metaDataQu?.metaDataDrivers}
                />
            ),
            showArrow: false,
        },
        overTime: {
            key: "overTime",
            label: "Over Time:",
            children: (
                <FilterOverTimeSelector
                    interval={interval}
                    filters={filters}
                    setInterval={setIntervalDate}
                    selectedDateName={selectedDateName}
                    setSelectedDateName={setSelectedDateName}
                    metaDataDate={metaDataQu?.metaDataDate}
                    selectedDateField={selectedDateField}
                />
            ),
            showArrow: false,
        },
        includeExamples: {
            key: "includeExamples",
            label: "Include examples:",
            children: (
                <IncludeExamples
                    selectedOption={includeExamples}
                    onChange={setIncludeExamples}
                />
            ),
            showArrow: false,
        },
        visualizeMatches: {
            key: "visualizeMatches",
            label: "Visualize matches as:",
            children: (
                <VisualizeSelector
                    selectedType={visualizeType}
                    setSelectedType={setVisualizeType}
                />
            ),
            showArrow: false,
        },
        scoreFilterWithIntervals: {
            key: "scoreFilterWithIntervals",
            label: "Select Score/Number:",
            children: (
                <ScoreFilterWithInterval
                    widget={widget}
                    setDisplayName={setDisplayName}
                    selectedFieldDriverName={selectedFieldDriverName}
                    setSelectedFieldDriverName={setSelectedFieldDriverName}
                    metaDataDrivers={metaDataQu?.metaDataDrivers}
                    metadata={metaDataQu.metaData}
                    setDriverInterval={setDriverInterval}
                    driverInterval={driverInterval}
                />
            ),
            showArrow: false,
        },
        npsScoreFilter: {
            key: "npsScoreFilter",
            label: "Select Score/Number:",
            children: (
                <NPSOverTimeFilter
                    widget={widget}
                    setDisplayName={setDisplayName}
                    selectedFieldDriverName={selectedFieldDriverName}
                    setSelectedFieldDriverName={setSelectedFieldDriverName}
                    metaData={metaDataQu}
                />
            ),
            showArrow: false,
        },
    };
    const getStaticCollapsedData = () => {
        const sharedFilters = [filterItems.conceptLists, filterItems.concepts, filterItems.filterName, filterItems.filterValue, filterItems.pageSize];
        const overTimeFilters = [...sharedFilters, filterItems.overTime];
        const driverFilters = [filterItems.filterScore, ...sharedFilters, filterItems.matchType];
        const volumeFilters = [...sharedFilters, filterItems.matchType, filterItems.visualizeMatches];

        switch (props.widget.text) {
            case WidgetNames.NUMBER_METADATA_BREAKDOWN:
            case WidgetNames.NPS_BREAKDOWN:
                return [filterItems.scoreFilterWithIntervals, filterItems.filterName, filterItems.filterValue];
            case WidgetNames.NPS_SCORE_OVERTIME:
                return [filterItems.filterName, filterItems.filterValue, filterItems.overTime];
            case WidgetNames.NPS_SCORE:
                return [filterItems.npsScoreFilter, filterItems.filterName, filterItems.filterValue];
            case WidgetNames.SENTIMENT:
            case WidgetNames.SENTIMENT_SHARE_BAR_CHART:
            case WidgetNames.SENTIMENT_SHARE:
                return sharedFilters;
            case WidgetNames.NET_SENTIMENT_FOR_CONCEPT_OVER_TIME:
            case WidgetNames.SENTIMENT_OVER_TIME_LINE:
                return overTimeFilters;
            case WidgetNames.VOLUME:
                return [...sharedFilters];
            case WidgetNames.OVERALL_SENTIMENT:
                return [...sharedFilters];
            case WidgetNames.LARGEST_CONCEPT_MOVEMENT:
                return [...sharedFilters, filterItems.matchType, filterItems.overTime];
            case WidgetNames.LARGEST_NET_SENTIMENT_MOVEMENT:
                return [...overTimeFilters];
            case WidgetNames.IMPACT_SCORE:
            case WidgetNames.DRIVERS:
                return driverFilters;
            case WidgetNames.AVERAGE_SCORE_OVERTIME:
                return [filterItems.filterScore, filterItems.filterName, filterItems.filterValue, filterItems.overTime];
            case WidgetNames.DRIVERS_DIFFERENCE_FROM_AVERAGE:
            case WidgetNames.DRIVERS_OVER_TIME:
            case WidgetNames.LARGEST_DRIVERS_MOVEMENT:
                return [filterItems.filterScore, ...overTimeFilters];
            case WidgetNames.METADATA_SHARE_OF_VOICE_OVER_TIME:
                return [filterItems.overTime];
            case WidgetNames.VOLUME_OVER_TIME:
            case WidgetNames.SHARE_OF_VOICE_OVER_TIME_BUBBLE:
                return [...sharedFilters, filterItems.overTime];
            case WidgetNames.SHARE_OF_VOICE_OVER_TIME:
                return [...volumeFilters, filterItems.overTime];
            case WidgetNames.OUTLIER_PERCENTAGE:
                return [filterItems.conceptLists,filterItems.filterScore];
            case WidgetNames.DOCUMENTS:
                return [filterItems.filterName, filterItems.filterValue];
            case WidgetNames.AVERAGE_SCORE:
                return [filterItems.filterScore, filterItems.filterName, filterItems.filterValue];
            case WidgetNames.METADATA_CONCEPT_VOLUME:
                return [filterItems.conceptLists];
            default:
                return [];
        }
    };

    const staticCollapsedData = [...getStaticCollapsedData(),...additionalFilters,];

    const defaultActiveKeys = staticCollapsedData
        .filter(
            (item) =>
                item.key === "filterScore" || item.key === "scoreFilterWithIntervals" || item.key === "Special" || item.key === "npsScoreFilter",
        )
        .map((item) => item.key);

    return (
        <div onMouseDown={(e) => e.stopPropagation()}>
            <Collapse
                onMouseDown={(e) => e.stopPropagation()}
                items={staticCollapsedData.map((item) => ({
                    ...item,
                    children: <div style={{ margin: "16px 0" }}>{item.children}</div>,
                }))}
                accordion={true}
                bordered={false}
                defaultActiveKey={defaultActiveKeys}
                size="small"
            />
            {widget.gridData.lineChart &&
                <div style={{
                    position: "absolute",
                    left: "33%",
                    alignItems: "center",
                    bottom: "5%",
                }} onMouseDown={e => e.stopPropagation()}>
                    <Switch
                        checked={smoothLine}
                        onChange={setSmoothLine}
                        checkedChildren="Smooth"
                        unCheckedChildren="Straight"
                    />
                </div>
            }
        </div>
    );
};
